export const SalePointId = {
  BCN: 'BCN',
  MT2: 'MT2',
  MT4: 'MT4',
  FER: 'FER',
  SEV: 'SEV',
} as const;

export type SalePointIdValue = (typeof SalePointId)[keyof typeof SalePointId];

export interface SalePoint {
  literal: string;
  applicationOrigin: number;
  channelCode: string;
  id: SalePointIdValue;
}
